// extracted by mini-css-extract-plugin
export default {"hidden_div":"HiddenDiv_hidden_div__8aDOD"};